import { AmnIncomingEventSchema, type AmnIncomingEvent } from "./incomingEvents"

export const validateWindowMessage = ({
  data,
}: MessageEvent): AmnIncomingEvent | undefined => {
  const result = AmnIncomingEventSchema.safeParse(data)
  if (!result.success) {
    return undefined
  }
  return result.data
}
